import { SideMenuGroup } from '@v2/shared/Layouts/SideMenu';

/**
 * MagSpot's institutional pages.
 *
 * Hardcoded for the same reason DiscountMags' and TopMags' lists are: these are fixed
 * pages, none of them editable anywhere, and the same ones are already spelled out in the
 * footer — a table would add a deploy-time dependency without removing one.
 *
 * DiscountMags' grouping, minus the group MagSpot has no pages for: DiscountMags opens
 * with "Shop with Confidence" — guarantee, DiscountLock, reviews, payment methods — and
 * MagSpot publishes none of those. What is left is Policies then Help, in DiscountMags'
 * order within each, which is also how MagSpot's own footer already splits these same
 * pages into "Legal" and "About".
 *
 * The labels are DiscountMags' words for the same pages — "About Us", "FAQs", "Contact
 * Us", "Refund Policy" — so a shopper who knows one site reads the other. The hrefs are now
 * the same slugs as every other brand's, out of PageRegistry: the server marks an entry
 * current by comparing its path against `activePath`, which that registry supplies, so a
 * path spelled differently here is not a broken link — the old urls all 301 — but it is an
 * entry that can never be highlighted. `/help` is this brand's FAQ page; on DiscountMags
 * the same slug is a redirect off-site.
 *
 * No "Delivery Policy" here, though the footer keeps one. It is a link into the FAQ
 * rather than a page of its own, so in the rail it would point at an entry the rail
 * already lists and could never mark as current. It stays in the footer, where it reads
 * as the shortcut it is.
 *
 * Paths are relative; every one of them goes through buildUrl before it is rendered.
 */
export const INSTITUTIONAL_MENU: SideMenuGroup[] = [
  {
    title: 'Policies',
    items: [
      { label: 'Refund Policy', href: '/refund-policy' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Use', href: '/terms' },
      { label: 'Accessibility', href: '/accessibility' },
    ],
  },
  {
    title: 'Help',
    items: [
      { label: 'FAQs', href: '/help' },
      { label: 'Contact Us', href: '/contact' },
      { label: 'About Us', href: '/about-us' },
    ],
  },
];
